import { render, staticRenderFns } from "./FavoriteMarker.vue?vue&type=template&id=6151365a&scoped=true"
import script from "./FavoriteMarker.vue?vue&type=script&lang=js"
export * from "./FavoriteMarker.vue?vue&type=script&lang=js"
import style0 from "./FavoriteMarker.vue?vue&type=style&index=0&id=6151365a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6151365a",
  null
  
)

export default component.exports